import Vue from 'vue';
import {Task as TaskModel} from '@/interfaces/TaskInterfaces';
import TaskColumnMixin from '@/mixins/TaskColumnMixin';
import {humanReadableRole} from "@/enums/userRolesEnum";

const UNCOMPLETED_TAB_ID = -1;
const COMPLETED_TAB_ID = -2;

export default Vue.component('delegated-task-column', {
  name: 'DelegatedTaskColumn',
  props: {
    assignedTo: { type: Number }
  },
  mixins: [TaskColumnMixin],
  data() {
    return {
      focusedTab: UNCOMPLETED_TAB_ID,
      tabs: [] as any
    }
  },
  created() {
    if ((this as any).$store.state.viewState[(this as any).screenStateKey + "_TAB_STATE"]) {
      (this as any).focusedTab = (this as any).$store.state.viewState[(this as any).screenStateKey + "_TAB_STATE"];
    }
    (this as any).tabs = [
      {
        id: UNCOMPLETED_TAB_ID,
        name: 'Not Completed',
        isFocused: this.focusedTab === UNCOMPLETED_TAB_ID,
        tasks: []
      },
      {
        id: COMPLETED_TAB_ID,
        name: 'Recently Completed',
        isFocused: (this).focusedTab === COMPLETED_TAB_ID,
        tasks: []
      }
    ];
    this.setDelegatedTasks((this as any).tasks);
  },
  computed: {
    assignedToName(): string {
      if (this.assignedTo > 0) {
        return (this as any).userFullName(this.assignedTo) + "'s";
      } else {
        return humanReadableRole(this.assignedTo * -1);
      }
    }
  },
  methods: {
    setTasks(newTasks: TaskModel[]) {
      // When the Mixin calls this, tabs have not yet been created so we do nothing.
      // Our created() will call our unique tasks
      // When watchers fire, tabs have been created so we need to pass along the task set
      if (this.tabs.length > 0) {
        this.setDelegatedTasks(newTasks);
      }
    },
    setDelegatedTasks(newTasks: TaskModel[]) {
      (this as any).loadEditingTasksState(newTasks);
      const map = new Map<number, any>();
      for (const tab of (this as any).tabs) {
        tab.tasks = [];
        map.set(tab.id, tab);
      }
      // Need to make sure we work with a copy or Vuex gets angry we're making changes without it.
      (this as any).ourTasks = newTasks.map((task: TaskModel) => {
        const oldTask = (this as any).ourTasks.find((oldTask: TaskModel) => oldTask.id === task.id);
        const toReturn = Object.assign({}, task);
        toReturn.isEditing = oldTask ? oldTask.isEditing : task.isEditing;
        if (task.isComplete) {
          map.get(COMPLETED_TAB_ID).tasks.push(toReturn);
        } else {
          map.get(UNCOMPLETED_TAB_ID).tasks.push(toReturn);
        }
        return toReturn;
      });
    },
    focusOnTab(tab: any) {
      for (const aTab of (this as any).tabs) {
        aTab.isFocused = false;
      }
      tab.isFocused = true;
      this.$store.dispatch('viewState/updateViewState',
        {name: (this as any).screenStateKey + "_TAB_STATE", value: JSON.parse(JSON.stringify(tab.id))});

    },
  }
});



// WEBPACK FOOTER //
// ./src/componentsReusable/tasks/column/DelegatedTaskColumn.ts